module.exports = __webpack_public_path__ + "static/media/28DGC4.e8623093.jpg";